module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/nerve-1ac1a52b56db95924e8c87dd0833e19b.jpeg";